import Link from 'next/link'

import Button from 'components/Button'
import ConsultationForm from 'components/ConsultationForm'
import Header from 'components/Header'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { Main, Root } from './consultation.style'

export default function Consultation() {
  return (
    <Root>
      <Main>
        <Link href="/custom-bespoke" passHref legacyBehavior>
          <Button text="Custom & Bespoke" variant="inline" as="a" />
        </Link>
        <Spacer y={4} />
        <Header>Custom Consultation</Header>
        <Spacer y={8} />
        <Text prose>
          The skilled members of The Armoury team are happy to do a consultation regarding your goals in achieving a
          specific look or fit with our product offerings and capabilities.
        </Text>
      </Main>
      <div>
        <ConsultationForm />
      </div>
    </Root>
  )
}
